<div class="cowing-textarea-container">
  <div *ngIf="label.length > 0" class="cowing-textarea-label">
    {{ label | translate }}
  </div>
  <div class="cowing-textarea-container">
    <textarea
      #textarea
      *ngIf="!isForm"
      [ngClass]="['textarea-' + textareaStyle]"
      [placeholder]="placeholder"
      [(ngModel)]="value"
    ></textarea>
    <textarea
      [maxLength]="maxLength"
      [rows]="rows"
      #textarea
      *ngIf="isForm"
      [ngClass]="[
        control.invalid && control.touched ? 'textarea-invalid' : '',
        'textarea-' + textareaStyle
      ]"
      [placeholder]="placeholder"
      [formControl]="control"
    ></textarea>
  </div>
</div>
